<template>
  <v-card class="elevation-0 shadow white mt-3 pb-3 flex mt-3">
    <v-card-text>
      <div class="flex-row align-center justify-start">
        <div class="py-2 px-3 lable-out">
          <h4>
            {{ title }}
            <span v-if="selected_currencies"
              >({{ receivable ? $t("receiveables") : $t("payables") }})</span
            >
          </h4>
        </div>
        <v-spacer />
        <v-autocomplete
          outline
          single-line
          hide-details
          :items="types"
          item-text="text"
          v-if="showFilter"
          item-value="value"
          style="max-width: 300px"
          v-model="selected_type"
        >
        </v-autocomplete>
        <!-- <v-autocomplete
          outline
          multiple
          clearable
          single-line
          hide-details
          return-object
          item-value="id"
          item-text="name"
          v-if="showFilter"
          :items="currencies"
          :label="$t('currency')"
          style="max-width: 300px"
          v-model="selected_currencies"
        /> -->
        <v-btn color="grey darken-2 mb-2" flat icon @click="printTable(false)">
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          color="grey darken-2"
          class="mb-2 mx-0"
          flat
          icon
          @click="printTable(true)"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </div>
      <v-data-table
        hide-actions
        :headers="headers"
        :hide-headers="external"
        :items="computed_customers"
      >
        <template slot="items" slot-scope="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ $t(item.type) }}</td>
            <td>{{ item.name }}</td>
            <td
              v-for="currency in computedCurrencies"
              :key="`${index}${currency.id}`"
              class="font-weight-bold"
              :class="{
                'red--text': item[currency.id] < 0,
                'activeColor--text': item[currency.id] > 0,
              }"
            >
              {{ item[currency.id] | currency }}
            </td>
            <td
              class="font-weight-bold"
              :class="{
                'red--text': item.total < 0,
                'activeColor--text': item.total > 0,
              }"
            >
              {{ item.total | currency }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <tr />
        </template>
        <template slot="footer">
          <tr>
            <td colspan="3" class="font-weight-medium body-2">
              {{ total.barrow.name }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              class="font-weight-medium body-2"
              :key="`barrow${currency.id}`"
            >
              {{
                total.barrow[currency.id]
                  | currency({ symbol: smbl(currency.id) })
              }}
            </td>
            <td
              class="font-weight-medium body-2"
              :class="{
                'red--text': total.barrow.total < 0,
                'activeColor--text': total.barrow.total > 0,
              }"
            >
              {{
                total.barrow.total
                  | currency({ symbol: smbl(base_currency.id) })
              }}
            </td>
          </tr>
          <tr>
            <td colspan="3" class="font-weight-medium body-2">
              {{ total.loan.name }}
            </td>
            <td
              v-for="currency in computedCurrencies"
              :key="`loan${currency.id}`"
              class="font-weight-medium body-2"
              :class="{
                'red--text': total.loan[currency.id] < 0,
                'activeColor--text': total.loan[currency.id] > 0,
              }"
            >
              {{
                total.loan[currency.id]
                  | currency({ symbol: smbl(currency.id) })
              }}
            </td>
            <td
              class="font-weight-medium body-2"
              :class="{
                'red--text': total.loan.total < 0,
                'activeColor--text': total.loan.total > 0,
              }"
            >
              {{
                total.loan.total | currency({ symbol: smbl(base_currency.id) })
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import curjs from "currency.js";
import { exchange } from "@/mixins/index.js";
export default {
  mixins: [exchange],
  props: {
    title: "",
    brnch_name: "",
    showFilter: false,
    customers: { default: () => [] },
    currencies: { default: () => [] },
    external: { default: () => false },
  },
  data: () => ({
    filter: false,
    selected_type: null,
    selected_currencies: null,
  }),
  computed: {
    types() {
      return [
        { value: null, text: this.$t("all") },
        { value: "receiveables", text: this.$t("receiveables") },
        { value: "payables", text: this.$t("payables") },
      ];
    },

    base_currency() {
      let currency = this.currencies.find(
        (x) => x.id === this.base_currency_id
      );
      return currency ? currency : { rank: 1, name: "", rate: 1 };
    },
    computedCurrencies: (vm) => vm.currencies,

    headers() {
      let items = [
        {
          text: this.$t("number"),
          sortable: false,
          width: "50px",
        },
        {
          value: "type",
          sortable: false,
          text: this.$t("type"),
          computed: (item) => this.$t(item.type),
        },
        {
          value: "name",
          text: this.$t("name"),
          sortable: false,
        },
      ];
      this.computedCurrencies.forEach((item) => {
        let va = item.id;
        items.push({
          text: item.name,
          sortable: false,
          value: va,
          width: "250px",
          computed: (ite) => curjs(ite[va]).format({ symbol: "" }),
        });
      });
      items.push({
        value: "total",
        sortable: false,
        computed: (item) => curjs(item.total).format({ symbol: "" }),
        text: this.$t("total") + " " + this.base_currency.name,
      });
      return items;
    },

    computed_customers() {
      let items = [...this.customers];
      items.forEach((item) => {
        let total = curjs(0);
        this.computedCurrencies.forEach((currency) => {
          let ex = this.exchange(
            currency,
            this.base_currency,
            item[currency.id] || 0,
            currency.rate
          );
          total = total.add(ex);
        });
        item.total = total.value;
      });

      if (this.selected_type == "receiveables")
        return items.filter((x) => x.total < 0);
      else if (this.selected_type == "payables")
        return items.filter((x) => x.total > 0);
      else return items;
    },

    total() {
      let barrow = { name: this.$t("payables"), class: "font-weight-bold" };
      let loan = { name: this.$t("receiveables"), class: "font-weight-bold" };

      this.computed_customers.forEach((item) => {
        this.computedCurrencies.forEach((currency) => {
          if (item[currency.id] < 0) {
            loan[currency.id] = curjs(loan[currency.id] || 0).add(
              item[currency.id]
            );
            let ex = this.exchange(
              currency,
              this.base_currency,
              item[currency.id] || 0,
              currency.rate
            );
            loan.total = curjs(loan.total || 0).add(ex);
          } else if (item[currency.id] > 0) {
            barrow[currency.id] = curjs(barrow[currency.id] || 0).add(
              item[currency.id]
            );
            let ex = this.exchange(
              currency,
              this.base_currency,
              item[currency.id] || 0,
              currency.rate
            );
            barrow.total = curjs(barrow.total || 0).add(ex);
          }
        });
      });
      return { loan, barrow };
    },
  },

  methods: {
    printTable(excel) {
      let items = this.computed_customers;

      items.push(this.total.barrow, this.total.loan);

      let data = {
        items: items,
        landscape: false,
        title: this.title,
        brnch_name:this.brnch_name,
        headers: this.headers.slice(1),
      };

      if (excel)
        return this.xl_tables(data, "customersAccounts", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
 